import { createBreakpoint } from "react-use";

export const useBreakPoint = createBreakpoint();
